'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_CertificateOfOriginGoodsEntryForm(description, grossWeight, netWeight, quantity, quantityUnit, unitPrice) {
  this.qF = null;
  this.og = null;
  this.oh = null;
  this.pJ = null;
  this.qG = null;
  this.pK = null;
  this.qF = description;
  this.og = grossWeight;
  this.oh = netWeight;
  this.pJ = quantity;
  this.qG = quantityUnit;
  this.pK = unitPrice;
}
export { $c_Lapp_data_CertificateOfOriginGoodsEntryForm as $c_Lapp_data_CertificateOfOriginGoodsEntryForm };
$p = $c_Lapp_data_CertificateOfOriginGoodsEntryForm.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_CertificateOfOriginGoodsEntryForm;
/** @constructor */
function $h_Lapp_data_CertificateOfOriginGoodsEntryForm() {
}
export { $h_Lapp_data_CertificateOfOriginGoodsEntryForm as $h_Lapp_data_CertificateOfOriginGoodsEntryForm };
$h_Lapp_data_CertificateOfOriginGoodsEntryForm.prototype = $p;
$p.z = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, (-889275714), false);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_data_CertificateOfOriginGoodsEntryForm)) {
    if ((this.qF === x$0.qF)) {
      var x = this.og;
      var x$2 = x$0.og;
      var $x_3 = ((x === null) ? (x$2 === null) : x.f(x$2));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$3 = this.oh;
      var x$4 = x$0.oh;
      var $x_2 = ((x$3 === null) ? (x$4 === null) : x$3.f(x$4));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$5 = this.pJ;
      var x$6 = x$0.pJ;
      var $x_1 = ((x$5 === null) ? (x$6 === null) : x$5.f(x$6));
    } else {
      var $x_1 = false;
    }
    if (($x_1 && (this.qG === x$0.qG))) {
      var x$7 = this.pK;
      var x$8 = x$0.pK;
      return ((x$7 === null) ? (x$8 === null) : x$7.f(x$8));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.n = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().V(this);
});
$p.s = (function() {
  return 6;
});
$p.t = (function() {
  return "CertificateOfOriginGoodsEntryForm";
});
$p.e = (function(n) {
  switch (n) {
    case 0: {
      return this.qF;
      break;
    }
    case 1: {
      return this.og;
      break;
    }
    case 2: {
      return this.oh;
      break;
    }
    case 3: {
      return this.pJ;
      break;
    }
    case 4: {
      return this.qG;
      break;
    }
    case 5: {
      return this.pK;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.u = (function(n) {
  switch (n) {
    case 0: {
      return "description";
      break;
    }
    case 1: {
      return "grossWeight";
      break;
    }
    case 2: {
      return "netWeight";
      break;
    }
    case 3: {
      return "quantity";
      break;
    }
    case 4: {
      return "quantityUnit";
      break;
    }
    case 5: {
      return "unitPrice";
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.Es = (function() {
  return this.pJ;
});
$p.Kb = (function() {
  return this.pK;
});
function $isArrayOf_Lapp_data_CertificateOfOriginGoodsEntryForm(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jf)));
}
export { $isArrayOf_Lapp_data_CertificateOfOriginGoodsEntryForm as $isArrayOf_Lapp_data_CertificateOfOriginGoodsEntryForm };
var $d_Lapp_data_CertificateOfOriginGoodsEntryForm = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_CertificateOfOriginGoodsEntryForm, "app.data.CertificateOfOriginGoodsEntryForm", ({
  jf: 1,
  jz: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lapp_data_CertificateOfOriginGoodsEntryForm as $d_Lapp_data_CertificateOfOriginGoodsEntryForm };
//# sourceMappingURL=app.data.-Certificate-Of-Origin-Goods-Entry-Form.js.map
